import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from './hooks';
import { BulkOperation, subscribeToBulkProgress } from './bulkProgressSlice';

export function useBulkProgressReconnect() {
    const dispatch = useAppDispatch();
    const rehydrated = useAppSelector((state: any) => state._persist?.rehydrated === true);
    const operations = useAppSelector(state => state.bulkProgress.operations);
    const reconnected = useRef(false);

    useEffect(() => {
        if (!rehydrated || reconnected.current) return;
        reconnected.current = true;

        (Object.values(operations) as BulkOperation[])
            .filter(op => !op.completed)
            .forEach(op => dispatch(subscribeToBulkProgress(op.operationId)));
    }, [rehydrated]); // eslint-disable-line react-hooks/exhaustive-deps
}
